const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

const fittedHeight = ({ width, availableHeight, aspectRatio, target }) => {
  const targetAspect = (target.width * aspectRatio) / target.height;
  return Math.min(width / targetAspect, availableHeight) / target.height;
};

export const placeMarker = (box, marker) => ({
  left: box.left + marker.left * box.width,
  top: box.top + marker.top * box.height,
});

export function layoutHero({ width, height, band, aspectRatio, target }) {
  const availableHeight = band.bottom - band.top;
  const imageHeight = Math.max(
    fittedHeight({ width, availableHeight, aspectRatio, target }),
    height,
    width / aspectRatio
  );
  const imageWidth = imageHeight * aspectRatio;

  const left = clamp(
    width / 2 - (target.left + target.width / 2) * imageWidth,
    width - imageWidth,
    0
  );
  const top = clamp(
    band.top + availableHeight / 2 -
      (target.top + target.height / 2) * imageHeight,
    height - imageHeight,
    0
  );

  return {
    image: { left, top, width: imageWidth, height: imageHeight },
    target: {
      left: left + target.left * imageWidth,
      top: top + target.top * imageHeight,
      width: target.width * imageWidth,
      height: target.height * imageHeight,
    },
  };
}
